import React from 'react';
import { Button } from '@mui/material';

export default function ArrangeButton({ onClick, disabled }) {
  const effectiveDisabled = !!disabled;
  return (
    <Button
      onClick={onClick}
      disabled={effectiveDisabled}
      style={{
        border: '2.5px solid ' + (effectiveDisabled ? '#ccc' : '#A7C667'),
        color: effectiveDisabled ? '#aaa' : '#A7C667',
        backgroundColor: effectiveDisabled ? '#f2f2f2' : 'transparent',
        padding: '0.3rem 2.2rem',
        borderRadius: '10px',
        fontSize: '1.1rem',
        fontWeight: 500,
        marginTop: '3rem',
        cursor: effectiveDisabled ? 'not-allowed' : 'pointer',
        fontFamily: 'Anek Latin',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      PROCEED TO CHECKOUT
    </Button>
  );
}
